import React, { Component } from 'react';
import FMButton from "../../../Button/Button";
import { Modal, Button } from 'antd';

class CancelAccountModal extends Component {
  state = {
    loading: false,
    visible: false,
    password: ''
  }

  onChange = (e) => {
    e.preventDefault();
    this.setState({ password: e.target.value })
  }

  showModal = () => {
    this.setState({
      visible: true,
    });
  }

  handleOk = () => {
    this.props.unsubcribePlan(this.state.password);
    this.setState({ loading: true });
    setTimeout(() => {
      this.setState({ loading: false, visible: false });
    }, 3000);
  }

  handleCancel = () => {
    this.setState({ visible: false });
  }

  render() {
    const { visible, loading, password } = this.state;
    return (
      <div>
        <FMButton label="Cancel Plan" onClick={this.showModal}/>
        <Modal
          visible={visible}
          title="Cancel Plan"
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          footer={[
            <Button key="back" onClick={this.handleCancel}>Go Back</Button>,
            <Button key="submit" type="primary" loading={loading} onClick={this.handleOk}>
              Finish Cancellation
            </Button>,
          ]}
        >
          <p>Are you sure you want to cancel your membership? Enter your password below to continue.</p>
          <input type="password" value={password} onChange={e => this.onChange(e)}/>
        </Modal>
      </div>
    );
  }
}

export default CancelAccountModal;


// WEBPACK FOOTER //
// ./src/components/Account/EditAccount/CancelAccountModal/CancelAccountModal.js